import { PoolGameObject } from "./PoolGameObject";

type PoolEntry<T> = {
	obj: T;
	active: boolean;
}

export class ObjectPool<T extends PoolGameObject> {

	private create: () => T;
	private list: PoolEntry<T>[] = [];

	constructor(create: () => T, count: number) {
		this.create = create;
		for (let i = 0; i < count; i++) {
			this.createItem();
		}
	}

	createItem(): PoolEntry<T> {
		const obj = this.create();
		obj.objectPool = this;
		this.hideAttachments(obj);
		const entry = {
			obj: obj,
			active: false,
		};
		this.list.push(entry);
		return entry;
	}

	get(...args: Parameters<T["poolSetup"]>): T {
		let entry = this.list.find(o => !o.active);
		if (!entry) entry = this.createItem();
		entry.active = true;

		entry.obj.poolSetup(...args);
		this.showAttachments(entry.obj);
		return entry.obj;
	}

	free(obj: T): void {
		const entry = this.list.find(o => o.obj == obj);
		entry.active = false;

		this.hideAttachments(obj);
		obj.parentContainer?.remove(obj);

		obj.poolDestroy();
	}

	private showAttachments(obj: T): void {
		for (const attachment of obj.attachments) {
			attachment.visible = true;
		}
	}

	private hideAttachments(obj: T): void {
		for (const attachment of obj.attachments) {
			attachment.visible = false;
		}
	}

}